<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row m-0 mb-3">
      <div class="col-6">
        <button class="btn btn-primary" (click)="openscreenselector(selectorScreen)">
          Select
        </button>
      </div>
      <div class="col-6">
        <button class="btn btn-primary" (click)="nextMenu(button)">
          {{ button && button.nexttab_id ? "Edit" : "Create New" }}
        </button>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-4 offset-4">
        <app-mobile-view-slider
          class="rounded-2"
          *ngIf="tab"
          [fontSmaller]="fontSmaller"
          [inputTab]="tab"
        ></app-mobile-view-slider>
      </div>
    </div>
  </div>
</div>

<ng-template #selectorScreen let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="selector">Choose Screen</h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="modalRef?.hide()"
    ></button>
  </div>
  <div class="modal-body">
    <app-screen-selector
      (selectedIcon)="iconChange($event)"
    ></app-screen-selector>
  </div>
</ng-template>
